import { certificate_type_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateCertificateTypeEnum = (enumValue: certificate_type_enum) => {
  switch (enumValue) {
    case certificate_type_enum.BREEAM:
      return <Trans i18nKey="Enum_CertificateTypeEnum-BREEAM" />;
    case certificate_type_enum.DGNB:
      return <Trans i18nKey="Enum_CertificateTypeEnum-DGNB" />;
    case certificate_type_enum.ENERGY_STAR_SCORE:
      return <Trans i18nKey="Enum_CertificateTypeEnum-ENERGY_STAR_SCORE" />;
    case certificate_type_enum.HQE:
      return <Trans i18nKey="Enum_CertificateTypeEnum-HQE" />;
    case certificate_type_enum.LEED:
      return <Trans i18nKey="Enum_CertificateTypeEnum-LEED" />;
    case certificate_type_enum.LIVING_FUTURE_ZERO_CARBON:
      return <Trans i18nKey="Enum_CertificateTypeEnum-LIVING_FUTURE_ZERO_CARBON" />;
    case certificate_type_enum.LIVING_FUTURE_ZERO_ENERGY:
      return <Trans i18nKey="Enum_CertificateTypeEnum-LIVING_FUTURE_ZERO_ENERGY" />;
  }
};

export const translateCertificateTypeEnum_dynamic = (enumValue: certificate_type_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case certificate_type_enum.BREEAM:
      return t('Enum_CertificateTypeEnum-BREEAM');
    case certificate_type_enum.DGNB:
      return t('Enum_CertificateTypeEnum-DGNB');
    case certificate_type_enum.ENERGY_STAR_SCORE:
      return t('Enum_CertificateTypeEnum-ENERGY_STAR_SCORE');
    case certificate_type_enum.HQE:
      return t('Enum_CertificateTypeEnum-HQE');
    case certificate_type_enum.LEED:
      return t('Enum_CertificateTypeEnum-LEED');
    case certificate_type_enum.LIVING_FUTURE_ZERO_CARBON:
      return t('Enum_CertificateTypeEnum-LIVING_FUTURE_ZERO_CARBON');
    case certificate_type_enum.LIVING_FUTURE_ZERO_ENERGY:
      return t('Enum_CertificateTypeEnum-LIVING_FUTURE_ZERO_ENERGY');
  }
};
